import React, { useEffect, useReducer, useMemo } from 'react'

import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    gridClasses,
    ptBR
} from '@mui/x-data-grid-pro';

import {
    createTheme,
    ThemeProvider,
    StyledEngineProvider
} from '@mui/material/styles';

import { ptBR as corePtBR } from '@mui/material/locale';

import { Box, Grid, Tooltip, Button } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import useNotification from '../../Notification';

import api from '../../../api';
import ConfirmationDialogCaptcha from '../../Dialogs/ConfimationDialogCaptcha';
import defaultReducer from '../../../utils/defaultReducer';

import LoadingButton from '@mui/lab/LoadingButton';

import Loading from '../../Loading';

import { getSession } from '../../../auth';
import { alphabeticalSort } from '../../../utils/alphabeticalSort';
import {
    stringOperators,
    choiceOperators,
    numericOperators
} from '../../../utils/filterOperators';

import EditEscalationModal from './edit';

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);

const dataColumns = (setState) => [
    { field: 'nick', headerName: 'Número', flex: 1, filterOperators: stringOperators },
    {
        field: 'action', headerName: 'Ações',
        filterable: false, sortable: false,
        renderCell: (params) => (
            <>
                <Button className="action-button"
                    onClick={() => setState({ edit: params.row })}
                >
                    <EditIcon />
                </Button>
                <Button className="action-button delete"
                    onClick={() => {
                        setState({
                            delete: params.row
                        })
                    }}
                >
                    <DeleteIcon />
                </Button>
            </>
        ),
    }
]


const CustomToolbar = (setState) => {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <LoadingButton
                size="small"
                component="label"
                startIcon={<AddCircleIcon />}
                onClick={() => setState({ edit: {} })}
            >
                Adicionar
            </LoadingButton>
        </GridToolbarContainer>
    );
}

const deleteNonGrata = async (row, rows, setState) => {
    const response = await api.delete(`api/enterprises/${getSession().profile.enterprise.id}/nongrata/${row.id}/`)

    if (response.status !== 204) {
        useNotification(
            'Ops!',
            'Ocorreu um erro na requisição.',
            'danger'
        )
        return
    }

    useNotification(
        'Sucesso!',
        'Número removido com sucesso.',
        'success'
    )

    setState({
        rows: rows.filter((each) => each.id !== row.id),
        delete: false,
    })
}

const initialize = async (setState) => {
    const enterpriseId = getSession().profile.enterprise.id
    setState({loading: true})
    const res = await api.get(`api/enterprises/${enterpriseId}/nongrata/`)
    if (res.status === 200) {
        setState({ rows: res.data, loading: false })
        return
    }
    setState({ loading: false })
    useNotification(
        'Ops!',
        'Houve um problema com a sua requisição, contate um administrador.',
        'warning'
    )
    return
}

const NonGrata = () => {

    const enterpriseId = getSession()?.profile?.enterprise?.id

    const [state, setState] = useReducer(defaultReducer, {
        rows: [],
        loading: false,
        edit: null,
        delete: null,
    })


    useEffect(async () => {
        initialize(setState)
    }, [])


    return (
        <>
            {state.edit ?
                <EditEscalationModal
                    data={state.edit}
                    allRows={state.rows}
                    setParentState={setState}
                />
                :
                null
            }
            {state.delete ?
                <ConfirmationDialogCaptcha open={true}
                    title="Confirmação"
                    description={
                        <span>
                            Para confirmar a remoção do número, digite: <span style={{ 'fontWeight': 'bold' }}>remover</span> no campo abaixo.
                        </span>
                    }
                    handleClose={() => setState({ delete: null })}
                    handleSubmit={() => deleteNonGrata(state.delete, state.rows, setState)}
                    captcha="remover"
                />
                :
                null
            }
            <Loading loading={state.loading} />
            <Box className="escalation-container">
                <Grid container sx={{ height: '100%' }}>
                    <Box sx={{ width: '100%', height: '100%' }}>
                        <ThemeProvider theme={theme}>
                            <DataGridPro
                                disableSelectionOnClick
                                disableDensitySelector
                                density="compact"
                                columns={useMemo(() => dataColumns(setState), [])}
                                rows={state.rows}
                                components={{
                                    Toolbar: () => CustomToolbar(setState),
                                }}
                            />
                        </ThemeProvider>
                    </Box>
                </Grid>
            </Box>
        </>
    )
}

export default NonGrata
